import { render, staticRenderFns } from "./EditBillingForm.vue?vue&type=template&id=2b4c572e&"
import script from "./EditBillingForm.vue?vue&type=script&lang=ts&setup=true&"
export * from "./EditBillingForm.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports